import { ImMessage, InquiryType } from '@/pages/Inquiry/data';
import { request } from 'umi';

export async function getTopic(params: { type: InquiryType }) {
  return request('/hm/online-inquiry/mng/servers/topic', {
    params
  })  
};

export async function getInquiryList (params?: { size: number }) {
  return request('/hm/online-inquiry/mng/inquiry/list', {
    params
  })
};

export async function getMessageTopic () {
  return request('/hm/user/message-center/topic')
};

export async function getInquiryCountdown (params: { inquiryId: string }) {
  return request('/hm/online-inquiry/mng/countdown', {
    params
  })
};

export async function sendInquiryMessage (params: Partial<ImMessage>) {
  return request('/hm/online-inquiry/mng/servers/send', {
    method: 'POST',
    data: params
  })
};

export async function finishInquiry(params: { inquiryId: string }) {
  return request('/hm/online-inquiry/mng/inquiry/finish', {
    params
  })
};
